import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/tax-groups?include=organization`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/tax-groups/${id}?include=taxes,organization`,
      options
    )
    .then((response) => {
      let taxGroup = jsona.deserialize(response.data);
      delete taxGroup.links;
      return taxGroup;
    });
}

function add(taxGroup) {
  const payload = jsona.serialize({
    stuff: taxGroup,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/tax-groups?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(taxGroup) {
  const payload = jsona.serialize({
    stuff: taxGroup,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/tax-groups/${taxGroup.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/tax-groups/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
